var _line, _circle, _path, _circle2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 40,
    viewBox: "0 0 200 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 21,
    x2: 161,
    y2: 21,
    stroke: "url(#paint0_linear_433_36492)",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "#111111",
    stroke: "#505050",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2432 14.3945V25H20.3242V16.2549H20.2656L17.79 17.8369V16.0938L20.4121 14.3945H22.2432Z",
    fill: "#505050"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 20,
    r: 19,
    fill: "#111111",
    stroke: "#00C13A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.36 25V23.623L180.11 20.0049C181.179 18.9355 181.736 18.3057 181.736 17.4121C181.736 16.4307 180.959 15.8008 179.919 15.8008C178.821 15.8008 178.118 16.4893 178.132 17.5586H176.316C176.301 15.5518 177.81 14.248 179.934 14.248C182.102 14.248 183.567 15.5371 183.567 17.3242C183.567 18.5254 182.981 19.4922 180.901 21.4551L179.011 23.3301V23.4033H183.728V25H176.36Z",
    fill: "#00C13A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_433_36492",
    x1: 39,
    y1: 22.5,
    x2: 161,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C13A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress2);
export default __webpack_public_path__ + "static/media/Progress2.de54b8830e424c4d211b5e8e4869e7e7.svg";
export { ForwardRef as ReactComponent };